import React, { useState, useEffect } from "react";
import "./restaurant.scss";
import { GoLocation } from "react-icons/go";
import { FaStar } from "react-icons/fa";
import AddToFavorite from "../../commonComponents/add-to-favorite/addToFavorite";
import { WiTime7 } from "react-icons/wi";
import { BiCategory } from "react-icons/bi";

function Restaurant(props) {
  const {
    image,
    name,
    location,
    review,
    onClick,
    restaurant_id,
    timeDeliveryEstimate,
    category,
  } = props;
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    console.log(JSON.parse(sessionStorage.getItem("favorites")));
  }, [restaurant_id, isClicked]);

  return (
    <div
      className="restaurant-card"
      onClick={() => onClick({ name, location, review })}
    >
      <div className="restaurant-card-image">
        <img src={image} alt={name} />
      </div>
      <div className="description-restaurant">
        <div>
          <div className="name-restaurant-review-favorite">
            <div className="name-restaurant-review">
              <h2>{name}</h2>
            </div>
            <div className="favorite">
              <AddToFavorite
                restaurant_id={restaurant_id}
                setIsClicked={setIsClicked}
                isClicked={isClicked}
              />
            </div>
          </div>
          <div className="delivery-time-category">
            <WiTime7 /> ({timeDeliveryEstimate}-{timeDeliveryEstimate + 20}) min
            ,{" "}
            <h3 className="review-in-restaurant-card">
              <FaStar className="star-icon" />
              <div className="review-text">{review}</div>
            </h3>
            ,{" "}
            <div className="category">
              <BiCategory />
              {category}
            </div>
          </div>
        </div>
        {/* <h3>
          <GoLocation />
          {location}
        </h3> */}
      </div>
    </div>
  );
}

export default Restaurant;
